import classNames from 'classnames'
import './Order.layout.scss'

export const OrderListLayout = defineComponent({
  name: 'OrderListLayout',
  inheritAttrs: false,
  setup(_props, { slots, attrs }) {
    return () => (
      <div {...attrs} class={classNames('order-list-layout', attrs.class as string)}>
        {slots.default?.()}
      </div>
    )
  },
})
